import script from "./EditPhoneNumberModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditPhoneNumberModal.vue?vue&type=script&setup=true&lang=js"

import "./EditPhoneNumberModal.vue?vue&type=style&index=0&id=9cdaba94&lang=css"

const __exports__ = script;

export default __exports__